import { IconButton, MenuItem, Select, Tooltip } from '@mui/material'
import Grid from '@mui/material/Grid2'
import GlobalMetricToggle from '../../../components/Charts/SearchConsoleChart/GlobalMetricToggle/GlobalMetricToggle'
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from '@mui/icons-material'
import DateRangeSelectorView from '../../../components/Selectors/DateRangeSelector/DateRangeSelectorView'
import { useTranslation } from 'react-i18next'
import ToggleCustomDots from '../../../components/Charts/SearchConsoleChart/ToggleCustomDots/ToggleCustomDots'
import * as React from 'react'
import { extractRootDomain } from '../../../utils/Utils'
import { useUserContext } from '../../../context/UserContext'


const ProjectsPerformanceFilterView = ({ model, controller }) => {
  const { t } = useTranslation();

  const { blur } = useUserContext();

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid>
        <Tooltip title={model.blur ? t('domains_hidden') : t('domains_visible')}>
          <IconButton sx={{ padding: 0 }} onClick={model.toggleBlur} aria-label="toggle blur">
            {model.blur ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid sx={{ display: { xs: 'none', md: 'block' } }}>
        <ToggleCustomDots active={model.showCustomDots} onClick={() => {
          model.setShowCustomDots(!model.showCustomDots);
        }} />
      </Grid>

      <Grid sx={{ display: { xs: 'none', md: 'block' } }}>
        <GlobalMetricToggle metrics={model.globalMetrics} onToggle={controller.handleGlobalMetricToggle} />
      </Grid>

      {model.customDomainData &&
        <Grid sx={{ display: { xs: 'none', md: 'block' }}}>
          <Select variant={'outlined'} value={model.columns}
                  onChange={(e)=> {model.setColumns(e.target.value)}}
                  displayEmpty
                  fullWidth
                  className={'projectSelector'}
                  MenuProps={{ disableScrollLock: true }}
                  sx={{ height: '30px'}}
                  defaultValue={2}
          >
            <MenuItem value="1">{t('1Column')}</MenuItem>
            <MenuItem value="2">{t('2Column')}</MenuItem>
            <MenuItem value="3">{t('3Column')}</MenuItem>
          </Select>
        </Grid>
      }

      <Grid>
        <DateRangeSelectorView onChange={controller.handleFilterUpdate} />
      </Grid>

      {model.projectsData &&
        <Grid>
          <Select variant={'outlined'} value={model.projectSelected || ''}
                  onChange={(event) => {
                    model.setProjectSelected(event.target.value)
                  }}
                  displayEmpty
                  fullWidth
                  className={'projectSelector'}
                  MenuProps={{ disableScrollLock: true }}
                  sx={{ height: '30px'}}
          >
            <MenuItem value="" disabled style={{ display: 'none' }} >{t('project')}</MenuItem>

            {model.projectsData && (
              model.projectsData
                .sort((a, b) => extractRootDomain(a.property).localeCompare(extractRootDomain(b.property)))
                .map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.property}>
                      <img
                        src={`https://www.google.com/s2/favicons?sz=32&domain=${extractRootDomain(item.property) || 'example.com'}`}
                        loading="lazy"
                        alt="favicon"
                        width={20}
                        height={20}
                        style={{ borderRadius: '50%', marginRight: '10px', verticalAlign: 'bottom' }}
                      />
                      <span className={blur && 'blurred'}>{extractRootDomain(item.property)}</span>
                    </MenuItem>
                  );
                })
            )}
          </Select>
        </Grid>
      }


    </Grid>
  );
};

export default ProjectsPerformanceFilterView;